<template>
    <div class="store" id="panel">
    <nav id="topnav">
      <div id="topnav-left">
        <a href="javascript:;">Games</a>
      </div>
      <div id="topnav-center" style="opacity: 0;">
        <img :src="visuals.icon"> 
      </div>
      <div id="topnav-right" style="opacity: 0;">
        <button class="btn-install" @click="onClickGet()">GET</button>
        <!-- <span>In-App Purchases</span> -->
      </div>
    </nav>
    <div id="main">
      <header>
        <div id="app-icon">
          <img :src="visuals.icon"> 
        </div>
        <div id="app-info">
          <div id="app-title">
            <h1>{{appName}}</h1>
            <h2>
              <span id="txt-subtitle" class="app-desc">{{appDescription}}</span>
              <!-- <span id="txt-publisher" style="margin-top: 50px">Bigger Games</span> -->
            </h2>
          </div>
          <div id="app-action">
            <button id="btn-get" class="btn-install" @click="onClickGet()">GET</button>
            <!--<span id="txt-get">In-App Purchases</span>-->
            <!-- <button id="btn-menu"></button> -->
          </div>
        </div>
      </header>

      <section id="section-rating">
        <div id="app-rating">
          <div id="app-stars">
            <span class="score">{{score}}</span>
            <span class="star-full"></span>
            <span class="star-full"></span>
            <span class="star-full"></span>
            <span class="star-full"></span>
            <span class="star-half"></span>
          </div>
          <label>{{rating}} Ratings</label>
        </div>
        <div id="app-ranking">
          <div id="app-position">
            <span>#</span>{{rank}}
          </div>
          <label>in {{category}}</label>
        </div>
        <div id="app-age">
          <span class="txt-age">{{age}}</span>
          <label class="txt-align-right">Age</label>
        </div>
      </section>

      <section id="section-gallery">
        <div class="swiper-container swiper-container-initialized swiper-container-horizontal">
          <!-- Additional required wrapper -->
          <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px);">
              <!-- Slides -->
              <div class="swiper-slide swiper-slide-active" style="margin-right: 10px;">
                <div class="gallery-img" @click="onGalleryImageClick">
                  <img :src="visuals.p1">
                </div>
              </div>
              <div class="swiper-slide swiper-slide-next" style="margin-right: 10px;">
                <div class="gallery-img" @click="onGalleryImageClick">
                <img :src="visuals.p2">
                </div>
              </div>
              <div class="swiper-slide" style="margin-right: 10px;">
                <div class="gallery-img" @click="onGalleryImageClick">
                <img :src="visuals.p3">
                </div>
              </div>
              <div class="swiper-slide" style="margin-right: 10px;">
                <div class="gallery-img" @click="onGalleryImageClick">
                <img :src="visuals.p4">
                </div>
              </div>
          </div>
        <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span></div>
      </section>

      <section id="section-offer">
        <a href="javascript:;" id="btn-offer">Offers iPad App</a>
        <a href="javascript:;" id="btn-offer-toggle"></a>
      </section>

      <hr>

      <section id="section-desc">
        <p>
            Hollo Ball will keep you hooked for hours! <br/> One finger control. Easy to play, hard to master.
        </p>
        <p id="txt-more" class="txt-fadeout">
            Features unlimited gameplay. <br/> Build your newest addiction!
        </p>
        <p id="btn-more"><a href="javascript:;">more</a></p>
      </section>

      <section id="section-dev">
        <p>
          <a href="javascript:;">Bigger Games</a>
          <label>Developer</label>
        </p>
        <a href="javascript:;" id="btn-toggle"></a>
      </section>
    </div>

    <div id="rest">
      <img :src="visuals.landing" style="display: block;width:100%;">
    </div>

    <div id="gallery" :class="fade_class">
        <div id="nav-gallery">
            <a @click="onClickDone">Done</a>
        </div>
        <div id="gallery-items">
        <div id="gallery-swiper-container" class="swiper-container swiper-container-initialized swiper-container-horizontal">
            <!-- Additional required wrapper -->
            <div class="swiper-wrapper" style="transform: translate3d(0px, 0px, 0px);">
                <!-- Slides -->
                <div class="swiper-slide swiper-slide-active" style="margin-right: 10px;">
                    <div class="gallery-img">
                    <img :src="visuals.m1">
                    </div>
                </div>
                <div class="swiper-slide swiper-slide-next" style="margin-right: 10px;">
                    <div class="gallery-img">
                    <img :src="visuals.m2">
                    </div>
                </div>
                <div class="swiper-slide" style="margin-right: 10px;">
                    <div class="gallery-img">
                    <img :src="visuals.m3">
                    </div>
                </div>
                <div class="swiper-slide" style="margin-right: 10px;">
                    <div class="gallery-img">
                    <img :src="visuals.m4">
                    </div>
                </div>
            </div>
            <span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span><span class="swiper-notification" aria-live="assertive" aria-atomic="true"></span></div>
        </div>
    </div>
  </div>

    

</template>

<script>
    import Swiper from 'swiper'
    import '@/assets/js/plugins/bodyScrollLock.min.js'
    import $ from 'jquery'

    
    
    export default {
        beforeCreate () {
          var userAgent = navigator.userAgent || navigator.vendor || window.opera;

            var currentOs = "PC";
            if (/windows phone/i.test(userAgent)) {
                currentOs = "Windows Phone";
            }

            if (/android/i.test(userAgent)) {
                currentOs = "Android";
            }

            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                currentOs = "iOS";
            }

            if(currentOs == "PC")
                location.href = "https://biggergames.net";

        },
        created () {
            var fbPixelId = "656326074858407";
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window,document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', fbPixelId); 
            fbq('track', 'PageView');
            this.fbpId = fbPixelId;
        },
        data() {
            return {
                active : true,
                class : "",
                fbpId : "656326074858407",
                appName: "Hollo Ball",
                appDescription: "Infinite Fun!",
                developer: "Bigger Games",
                score: "4.6",
                rank: "116",
                category: "Action",
                age: "4+",
                rating: "5.3K",
                visuals: {
                  icon: require('@/assets/store_files/images/hollo/icon.png'),
                  landing: require('@/assets/store_files/images/hollo/landing.png'),
                  p1: require('@/assets/store_files/images/hollo/p1.png'),
                  p2: require('@/assets/store_files/images/hollo/p2.png'),
                  p3: require('@/assets/store_files/images/hollo/p3.png'),
                  p4: require('@/assets/store_files/images/hollo/p4.png'),
                  m1: require('@/assets/store_files/images/hollo/1.jpg'),
                  m2: require('@/assets/store_files/images/hollo/2.jpg'),
                  m3: require('@/assets/store_files/images/hollo/3.jpg'),
                  m4: require('@/assets/store_files/images/hollo/4.jpg'),
                }
            }
        },
        computed: {
            fade_class() {
                if(this.active)
                    return this.class = "slide-down"
                else
                    return this.class = "slide-up"
            }
        },
        mounted () {
            var mySwiper = new Swiper ('.swiper-container', {
                slidesPerView: 'auto',
                spaceBetween: 10,
            });

            var mySwiper = new Swiper ('#gallery-swiper-container', {
                slidesPerView: 'auto',
                spaceBetween: 10,
            });

            var currentScrollPos = window.pageYOffset;
            if (currentScrollPos > 50) {
                document.getElementById("topnav-center").style.opacity = 1;
                document.getElementById("topnav-right").style.opacity = 1;
                document.getElementById("topnav-center").style.display = "block";
                document.getElementById("topnav-right").style.display = "block";
            } else {
                document.getElementById("topnav-center").style.opacity = 0;
                document.getElementById("topnav-right").style.opacity = 0;
            }

            document.addEventListener('scroll', this.onScroll);
        },
        methods: {
            onScroll () {
                var currentScrollPos = window.pageYOffset;
                if (currentScrollPos > 110) {
                    // document.getElementById("topnav-center").style.display = "block";
                    // document.getElementById("topnav-right").style.display = "block";
                    document.getElementById("topnav-center").className = "fade-in"
                    document.getElementById("topnav-right").className = "fade-in"
                    document.getElementById("topnav-center").style.display = "block";
                    document.getElementById("topnav-right").style.display = "block";
                } else {
                    // document.getElementById("topnav-center").style.display = "none";
                    // document.getElementById("topnav-right").style.display = "none";
                    document.getElementById("topnav-center").className = "fade-out"
                    document.getElementById("topnav-right").className = "fade-out"
                }
            },
            onGalleryImageClick() {
                this.active = false;
            },
            onClickDone() {
                this.active = true;
            },
            onClickGet() {
                var camp_ios   = "https://track.tenjin.io/v0/click/cuhMk6jWxJ9vxlcYxb6tl3";
                var camp_a_ios = "https://track.tenjin.io/v0/click/dIYPvW4kE4N5c71N2GLcjJ";
                var camp_b_ios = "https://track.tenjin.io/v0/click/doeGJEuZNBMNQyUQkKl5u3";
                var camp_c_ios = "https://track.tenjin.io/v0/click/dM59ughYbjzE3reDeHDQAH";

                var params = {};
                location.search.substr(1).split("&").forEach(function(item) { params[item.split("=")[0]] = item.split("=")[1] });
                var utm_source = params.site_source_name;
                //var utm_medium = params.placement;
                var utm_campaign = params.name;
                var ad_id = params.adid;
                var site_id = "Bigger";
                var os = params.os;
                var campType = params.camp;
                
                var _camp = "";
                if(campType == "a")       { _camp = camp_a_ios; }    
                else if(campType == "b")  { _camp = camp_b_ios; }    
                else if(campType == "c")  { _camp = camp_c_ios; }    
                else                      { _camp = camp_ios; }
                
                var red_URL = `${_camp}?advertising_id=${ad_id}&site_id=${site_id}&ad_network=${utm_source}&campaign_name=${utm_campaign}`;

                var register = window.localStorage.getItem(this.fbpId);
                if (register) {
                var elapsed = Date.now() - register;
                console.log(elapsed);
                if (Math.floor(elapsed / 1000) < 10) {
                    location.href = red_URL
                    return
                }
                }
            
                fbq('track', 'Lead');
                window.localStorage.setItem(this.fbpId, Date.now());
                location.href = red_URL;
            }
        },
        beforeDestroy() {
            document.removeEventListener('scroll', this.onScroll);
        }
    }
</script>

<style lang="scss" scoped>
    body {
      h1, h2, h3, h4, h5, h6, p, a, label, span, button, #app-position
      {
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif !important;
      }

      h1 {
        font-weight: 600!important;
      }

      .app-desc {
        font-size : 14px;
        margin-top: 4px;
      }

      #section-desc {
        color: black;
      }
    }
    @font-face {
        font-family: "SF Display"!important;
        font-weight: 900;
        src: url("https://sf.abarba.me/SF-UI-Display-Black.otf");
        }

        /** Bold */
        @font-face {
        font-family: "SF Display"!important;
        font-weight: 700;
        src: url("https://sf.abarba.me/SF-UI-Display-Bold.otf");
        }

        /** Heavy */
        @font-face {
        font-family: "SF Display"!important;
        font-weight: 800;
        src: url("https://sf.abarba.me/SF-UI-Display-Heavy.otf");
        }

        /** Light */
        @font-face {
        font-family: "SF Display"!important;
        font-weight: 200;
        src: url("https://sf.abarba.me/SF-UI-Display-Light.otf");
        }

        /** Medium */
        @font-face {
        font-family: "SF Display"!important;
        font-weight: 500;
        src: url("https://sf.abarba.me/SF-UI-Display-Medium.otf");
        }

        /** Regular */
        @font-face {
        font-family: "SF Display"!important;
        font-weight: 400;
        src: url("https://sf.abarba.me/SF-UI-Display-Regular.otf");
        }

        /** Semibold */
        @font-face {
        font-family: "SF Display"!important;
        font-weight: 600;
        src: url("https://sf.abarba.me/SF-UI-Display-Semibold.otf");
        }

        /** Thin */
        @font-face {
        font-family: "SF Display"!important;
        font-weight: 300;
        src: url("https://sf.abarba.me/SF-UI-Display-Thin.otf");
        }

        /** Ultralight */
        @font-face {
        font-family: "SF Display"!important;
        font-weight: 100;
        src: url("https://sf.abarba.me/SF-UI-Display-Ultralight.otf");
        }


   html {
    color: #222;
    font-size: 1em;
    line-height: 1.4;
}

/*
 * Remove text-shadow in selection highlight:
 * https://twitter.com/miketaylr/status/12228805301
 *
 * Vendor-prefixed and regular ::selection selectors cannot be combined:
 * https://stackoverflow.com/a/16982510/7133471
 *
 * Customize the background color to match your design.
 */

::-moz-selection {
    background: #b3d4fc;
    text-shadow: none;
}

::selection {
    background: #b3d4fc;
    text-shadow: none;
}

/*
 * A better looking default horizontal rule
 */

hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid #ccc;
    margin: 1em 0;
    padding: 0;
}

/*
 * Remove the gap between audio, canvas, iframes,
 * images, videos and the bottom of their containers:
 * https://github.com/h5bp/html5-boilerplate/issues/440
 */

audio,
canvas,
iframe,
img,
svg,
video {
    vertical-align: middle;
}

/*
 * Remove default fieldset styles.
 */

fieldset {
    border: 0;
    margin: 0;
    padding: 0;
}

/*
 * Allow only vertical resizing of textareas.
 */

textarea {
    resize: vertical;
}

/* ==========================================================================
   Browser Upgrade Prompt
   ========================================================================== */

.browserupgrade {
    margin: 0.2em 0;
    background: #ccc;
    color: #000;
    padding: 0.2em 0;
}




 /* ==========================================================================
   Author's custom styles
   ========================================================================== */
















 /* ==========================================================================
   Helper classes
   ========================================================================== */

/*
 * Hide visually and from screen readers
 */

 .hidden {
  display: none !important;
}

/*
* Hide only visually, but have it available for screen readers:
* https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
*
* 1. For long content, line feeds are not interpreted as spaces and small width
*    causes content to wrap 1 word per line:
*    https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
*/

.visuallyhidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap; /* 1 */
}

/*
* Extends the .visuallyhidden class to allow the element
* to be focusable when navigated to via the keyboard:
* https://www.drupal.org/node/897638
*/

.visuallyhidden.focusable:active,
.visuallyhidden.focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
  white-space: inherit;
}

/*
* Hide visually and from screen readers, but maintain layout
*/

.invisible {
  visibility: hidden;
}

/*
* Clearfix: contain floats
*
* For modern browsers
* 1. The space content is one way to avoid an Opera bug when the
*    `contenteditable` attribute is included anywhere else in the document.
*    Otherwise it causes space to appear at the top and bottom of elements
*    that receive the `clearfix` class.
* 2. The use of `table` rather than `block` is only necessary if using
*    `:before` to contain the top-margins of child elements.
*/

.clearfix:before,
.clearfix:after {
  content: " "; /* 1 */
  display: table; /* 2 */
}

.clearfix:after {
  clear: both;
}

 
/* ==========================================================================
   EXAMPLE Media Queries for Responsive Design.
   These examples override the primary ('mobile first') styles.
   Modify as content requires.
   ========================================================================== */

   @media only screen and (min-width: 35em) {
    /* Style adjustments for viewports that meet the condition */
}

@media print,
       (-webkit-min-device-pixel-ratio: 1.25),
       (min-resolution: 1.25dppx),
       (min-resolution: 120dpi) {
    /* Style adjustments for high resolution devices */
}

 
/* ==========================================================================
   Print styles.
   Inlined to avoid the additional HTTP request:
   https://www.phpied.com/delay-loading-your-print-css/
   ========================================================================== */

   @media print {
    *,
    *:before,
    *:after {
        background: transparent !important;
        color: #000 !important; /* Black prints faster */
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        text-shadow: none !important;
    }

    a,
    a:visited {
        text-decoration: underline;
    }

    a[href]:after {
        content: " (" attr(href) ")";
    }

    abbr[title]:after {
        content: " (" attr(title) ")";
    }

    /*
     * Don't show links that are fragment identifiers,
     * or use the `javascript:` pseudo protocol
     */

    a[href^="#"]:after,
    a[href^="javascript:"]:after {
        content: "";
    }

    pre {
        white-space: pre-wrap !important;
    }
    pre,
    blockquote {
        border: 1px solid #999;
        page-break-inside: avoid;
    }

    /*
     * Printing Tables:
     * http://css-discuss.incutio.com/wiki/Printing_Tables
     */

    thead {
        display: table-header-group;
    }

    tr,
    img {
        page-break-inside: avoid;
    }

    p,
    h2,
    h3 {
        orphans: 3;
        widows: 3;
    }

    h2,
    h3 {
        page-break-after: avoid;
    }
}

* {box-sizing: border-box;touch-action:manipulation;-webkit-user-select: none; }
body {font-family: 'Helvetica'!important, sans-serif!important; font-weight:400!important; color: #303030; margin:0;padding:0;}
hr {margin: 0 5%;}
p, h1, h2, h3, h4 {margin: 0; padding: 0;}
a {-webkit-tap-highlight-color:transparent;text-decoration: none!important; color:#3478f6!important; font-weight: bolder; font-size: 16px;}
a:active, a:focus {outline:none;}
.txt-align-right {text-align: right;}

.fade-in {
	animation: fadeIn ease 0.3s;
	-webkit-animation: fadeIn ease 0.3s;
	-moz-animation: fadeIn ease 0.3s;
	-o-animation: fadeIn ease 0.3s;
	-ms-animation: fadeIn ease 0.3s;
}

.fade-out {
	animation: fadeOut ease 0.3s;
	-webkit-animation: fadeOut ease 0.3s;
	-moz-animation: fadeOut ease 0.3s;
	-o-animation: fadeOut ease 0.3s;
	-ms-animation: fadeOut ease 0.3s;
}

.fade-in-06 {
	animation: fadeIn ease 1s;
	-webkit-animation: fadeIn ease 1s;
	-moz-animation: fadeIn ease 1s;
	-o-animation: fadeIn ease 1s;
	-ms-animation: fadeIn ease 1s;
}

.fade-out-06 {
	animation: fadeOut ease 1s;
	-webkit-animation: fadeOut ease 1s;
	-moz-animation: fadeOut ease 1s;
	-o-animation: fadeOut ease 1s;
	-ms-animation: fadeOut ease 1s;
}

.slide-up {
	animation: slideUp ease 0.5s;
	-webkit-animation: slideUp ease 0.5s;
	-moz-animation: slideUp ease 0.5s;
	-o-animation: slideUp ease 0.5s;
	-ms-animation: slideUp ease 0.5s;
}

.slide-down {
	animation: slideDown ease 0.5s;
	-webkit-animation: slideDown ease 0.5s;
	-moz-animation: slideDown ease 0.5s;
	-o-animation: slideDown ease 0.5s;
	-ms-animation: slideDown ease 0.5s;
}

@keyframes fadeIn{
  0% {
    opacity:0;
  }
  100% {
    opacity:1;
  }
}

@keyframes fadeOut{
  0% {
    opacity:1;
  }
  100% {
    opacity:0;
  }
}

@keyframes slideUp{
  0% {
    top:100%;
  }
  100% {
    top:0%;
  }
}

@keyframes slideDown{
  0% {
    top:0%;
  }
  100% {
    top:100%;
  }
}

#guide {
	width:100%;
	height:10000px;
	// background: transparent url(../img/guide.png) no-repeat;
	position: absolute;
	background-size: contain;
	opacity: 0.6;
}

#panel {
	
}

#panel #main {
	padding-top:48px;
}

#panel nav {
	overflow: hidden;
	padding:10px 3%;
	height:48px;
	position:fixed;
	width:100%;
	background:#fff;
	z-index:9999;
}

#panel nav #topnav-left {
	overflow: hidden;
	width:40%;
	height: 40px;
	float: left;
}

#panel nav #topnav-left a { 
	display: block;
	height:24px;
	line-height: 20px;
	// background:transparent url(../img/appstore/icon_topnav_back.png) no-repeat;
	background-size:contain;
	padding:2px 0 2px 18px;
	font-size:16px;
}

#panel nav #topnav-center {
	overflow: hidden;
	width:20%;
	height: 40px;
	float: left;
	text-align: center;
	animation-fill-mode: forwards;
	display: none;
}

#panel nav #topnav-center img {
	display: block;
	height:28px;
	margin: 0 auto;
	border-radius: 10px;
	border:solid 1px #f8f8f8;
}

#panel nav #topnav-right {
	overflow: hidden;
	width:40%;
	height: 40px;
	float: left;
	animation-fill-mode: forwards;
	display: none;
}

#panel nav #topnav-right button {
	width:60px;
	height:28px;
	line-height: 26px;
	margin:0;
	display:block;
	float:left;
	background:#3478f6;
	color:#fff;
	font-size:14px;
	font-weight:600;
	border-radius: 24px;
	border:0;
	float:right;
}

#panel nav #topnav-right span {
	width:40px;
	font-size:9px;
	line-height:10px;
	color:#8e8f92;
	display:block;
	float:right;
	margin:0 10px 0 0;
	padding:4px 0;
	text-align: right;
}

#main header {
	padding:14px 5%;
	overflow: hidden;
}

#main header #app-icon {
	float:left;
	width:35%;
}

#main header #app-info {
	float:left;
	width:60%;
	margin:0 0 0 5%;
}

#main header #app-info #app-title {
	overflow: hidden;
}

#main header #app-info #app-action {
	overflow: hidden;
}

#main header img {
	display:block;
	width:100%;
	border-radius: 25%;
	border:solid 1px #ccc;
}

#main header h1 {
	font-size:22px;
	font-weight:600;
	color:#000;
}

#main header h2 {
	font-size:16px;
	font-weight:400;
	color:#8e8f92;
	height:54px;
}

#main header h2 span{
	display:block;
	animation-fill-mode: forwards;
}

#main header h2 span#txt-publisher{
	position:relative;
	top:-22px;
	margin-bottom:-24px;
	opacity: 0;
	display: none;
}

#main header button#btn-get {
	width:80px;
	height:34px;
	line-height: 34px;
	margin:0;
	display:block;
	float:left;
	background:#3478f6;
	color:#fff;
	font-weight:600;
	border-radius: 24px;
	border:0;
	font-size:16px;
}

#main header span#txt-get {
	width:40px;
	font-size:10px;
	line-height:11px;
	color:#8e8f92;
	display:block;
	float:left;
	margin:0 0 0 10px;
	padding:6px 0 0 0;
}

#main header button#btn-menu {
	width:34px;
	height:34px;
	line-height: 34px;
	margin:0;
	display:block;
	float:right;
	background:#3478f6;
	color:#fff;
	font-weight:500;
	border:0;
	// background:transparent url(../img/appstore/icon_menu.png) no-repeat;
	background-size:contain;
}


#main section#section-rating {
	padding:14px 5%;
	overflow: hidden;
}

#main section#section-rating label {
	display: block;
	font-size:11px;
	color:#9f9fa0;
}

#main section#section-rating #app-age label{
	text-align: center;
}

#main section#section-rating #app-rating{
	float:left;
}

#main section#section-rating #app-ranking{
	float:left;
	text-align: center;
	margin-left:50px;
}

#main section#section-rating #app-age{
	float:right;
}

#main section#section-rating #app-rating #app-stars{
	overflow:hidden;
	height:36px;
	line-height: 36px;
}

#main section#section-rating #app-rating #app-stars span.score {
	display:block;
	float:left;
	height:36px;
	line-height: 36px;
	color:#8e8f92;
	font-size:26px;
	font-weight: 500;
	padding-right:4px;
}

#main section#section-rating #app-rating #app-stars span.star-full {
	display:block;
	float:left;
	width:22px;
	height:20px;
	margin:7px 0;
	// background: transparent url(../img/appstore/icon_star.png) no-repeat;
	background-size: contain;
}

#main section#section-rating #app-rating #app-stars span.star-half {
	display:block;
	float:left;
	width:22px;
	height:20px;
	margin:7px 0;
	// background: transparent url(../img/appstore/icon_star_half.png) no-repeat;
	background-size: contain;
}

#main section#section-rating #app-rating #app-stars span.star-empty {
	display:block;
	float:left;
	width:22px;
	height:20px;
	margin:7px 0;
	// background: transparent url(../img/appstore/icon_star_empty.png) no-repeat;
	background-size: contain;
}

#main section#section-rating #app-age span.txt-age {
	display:block;
	float:right;
	height:36px;
	line-height: 36px;
	color:#8e8f92;
	font-size:26px;
	font-weight: 500;
}

#main section#section-rating #app-ranking #app-position{ 
	height:36px;
	font-size:26px;
	font-weight: 500;
	color:#8e8f92;
}

#main section#section-rating #app-ranking #app-position span {
	font-size:17px;
	vertical-align: top;
	line-height: 30px;
}

#main section#section-gallery {
	padding:14px 5%;
	overflow: hidden;
}

.swiper-container {
    width: 100%;
    height: 100%;
}

.swiper-slide {
	width:60%;
}

.gallery-img {
	/*width:220px;*/
}

.gallery-img img {
	display: block;
	width: 100%;
	/*height:100%;*/
	border-radius: 16px;
	/*border:solid 1px #ccc;*/
}

#main section#section-desc {
	padding:14px 5%;
	overflow: hidden;
}

#main section#section-desc p {
	line-height: 22px;
}

#main section#section-desc p.txt-fadeout {
	width:80%;
	height:22px;
	float:left;
    background-image: linear-gradient(90deg,#000000 0%,rgba(0,0,0,0));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    position:relative;
    display:inline-block;
}

#main section#section-desc p#btn-more {
	width:20%;
	float:left;
}

#gallery {
	position:fixed;
	width:100%;
	height:100%;
	background:white;
	top:100%;
	z-index:10000;
	animation-fill-mode: forwards;
	padding:0 5%;

}

#gallery #nav-gallery {
	height:48px;
	padding:12px 0;
	line-height: 28px;
}

#gallery #nav-gallery a {
	display:block;
	float: right;
	line-height: 28px;
	font-weight:500;
}

#gallery #gallery-items {
	height:84%;
	margin:5% 0 0 0;
}

#gallery #gallery-items .gallery-img {
	height: 100%;
	overflow: hidden;
}

#gallery #gallery-items .gallery-img img { 
	width:100%;
	height:auto;
}

#gallery .swiper-slide {
	width:90%;
}


#main section#section-offer {
	padding:0 5% 14px 5%;
	overflow: hidden;
}

#main section#section-offer a#btn-offer { 
	display:block;
	color:#aaa;
	height:20px;
	line-height: 20px;
	font-size:13px;
	font-weight:500;
	float:left;
	// background:transparent url(../img/appstore/icon_ipad.png) no-repeat;
	background-size: contain;
	padding-left:30px;
}

#main section#section-offer a#btn-offer-toggle { 
	display:block;
	color:#aaa;
	width:20px;
	height:20px;
	font-size:13px;
	font-weight:500;
	float:right;
	// background:transparent url(../img/appstore/icon_down.png) no-repeat;
	background-size: contain;
}

#main section#section-dev {
	padding:0 5% 20px 5%;
	overflow: hidden;
}

#main section#section-dev p {
	float:left;
}

#main section#section-dev p a {
	font-size:16px;
	line-height: 20px;
	display: block;
}

#main section#section-dev p label {
	font-size:12px;
	line-height: 14px;
	color:#666;
	display: block;
}

#main section#section-dev a#btn-toggle {
	display:block;
	color:#aaa;
	width:20px;
	height:20px;
	font-size:14px;
	font-weight:500;
	float:right;
	// background:transparent url(../img/appstore/icon_right.png) no-repeat;
	background-size: contain;
}



</style>


// WEBPACK FOOTER //
// src/components/views/traffic/StoreHB.vue